module.exports = __webpack_public_path__ + "static/media/ic-calculator.2fd14e84.svg";